module.exports = __webpack_public_path__ + "static/wet-1871628ad5a9dda262de3823061bb91a.jpg";